import { render } from "./MatchMakingTab.vue?vue&type=template&id=8f81e7c2&scoped=true"
import script from "./MatchMakingTab.vue?vue&type=script&lang=js"
export * from "./MatchMakingTab.vue?vue&type=script&lang=js"

import "./MatchMakingTab.vue?vue&type=style&index=0&id=8f81e7c2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f81e7c2"]])

export default __exports__